import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import {  Navigate, useNavigate, useSearchParams } from "react-router-dom";
import FormContainer from "../../components/FormContainer/FormContainer";
import {WarningFilled,CloseCircleFilled,CheckSquareFilled  } from '@ant-design/icons';
import { ImageContainer, InfoText, StyledContainer } from "./style";
import { useAppSelector } from "../../redux/store/storehooks";


export const BankResponse = () => {

    const myStore = useAppSelector((state) => state)
    const [isLoading,setIsLoading] = useState(true);
    const [haveError,setHaveError] = useState(false);
    const [searchParams] = useSearchParams();
    const [hash,setHash] = useState<any>();
    const navigate = useNavigate();

    useEffect(()=>{

        let res = searchParams.get('Hash');
        setHash(res);
        setIsLoading(false);

        if (!res) setHaveError(true)
        if (res === null) setHaveError(true)
        if (res === "") setHaveError(true)
        if (res != "110011" && res != "1100011") setHaveError(true)


    },[])


    const backToHomePage = (e:any) => {
        e.preventDefault();

        if (myStore.auth){
            myStore.auth.loginType === 'labuser' ? navigate("/labuser/dashboard") : navigate("/parsicuser/dashboard");
        }
        else {
            navigate("/login");
        }
    }

    return (
       <StyledContainer>
            <FormContainer title="" onSubmit={backToHomePage} saveButtonTitle={"بازگشت به صفحه اصلی"} onCancel={undefined} cancelButtonTitle={""} isLoading={isLoading} isSubmiting={false} >

                {haveError && (
                    <>
                        <ImageContainer>
                            <Row>
                                <Col>
                                    <WarningFilled style={{ color: 'Red', fontSize: '128px' }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <InfoText>خطای پیش بینی نشده ای رخ داده است</InfoText>
                                    <InfoText>در صورتی که مبلغی از شما کسر شده باشد طی 72 ساعت آینده به حساب شما برگشت داده می شود</InfoText>
                                    <InfoText>در صورت نیاز به پشتیبانی با شماره تلفن 02149951000 تماس بفرمایید</InfoText>
                                </Col>
                            </Row>
                        </ImageContainer>
                    </>
                )}
                
                {!haveError && hash === "1100011" && (
                    <>
                        <ImageContainer>
                            <Row>
                                <Col>
                                    <CloseCircleFilled  style={{ color: 'Orange', fontSize: '128px' }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <InfoText>متاسفانه پرداخت شما نا موفق بوده است</InfoText>
                                    <InfoText>در صورتی که مبلغی از شما کسر شده باشد طی 72 ساعت آینده به حساب شما برگشت داده می شود</InfoText>
                                    <InfoText>در صورت نیاز به پشتیبانی با شماره تلفن 02149951000 تماس بفرمایید</InfoText>
                                </Col>
                            </Row>
                        </ImageContainer>
                    </>
                )}
                
                {!haveError && hash === "110011" && (
                    <>
                        <ImageContainer>
                            <Row>
                                <Col>
                                    <CheckSquareFilled  style={{ color: 'green', fontSize: '128px' }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <InfoText>پرداخت شما موفق بوده است</InfoText>
                                    <InfoText>با کلیک بر روی دکمه زیر به صفحه اصلی هدایت خواهید شد</InfoText>
                                    <InfoText>در صورت نیاز به پشتیبانی با شماره تلفن 02149951000 تماس بفرمایید</InfoText>
                                </Col>
                            </Row>
                        </ImageContainer>
                    </>
                )}


            </FormContainer>
       </StyledContainer>
    )

}